import { useContext, useMemo } from 'react';
import { ActiveBrandContext, UserBrandsContext } from './UserBrandsContext';

export function useActiveBrandIdentifier() {
  const activeBrandIdentifier = useContext(ActiveBrandContext);
  return activeBrandIdentifier;
}

export function useActiveBrand() {
  const activeBrandIdentifier = useContext(ActiveBrandContext);
  const userBrands = useContext(UserBrandsContext);

  return useMemo(() => {
    return userBrands.find((brand) => brand.identifier === activeBrandIdentifier) || null;
  }, [activeBrandIdentifier, userBrands]);
}
